import { RouterEngine } from '@biketravel/solid-router';
import { routes } from './routing';

export const router = new RouterEngine(routes);
